import Config from '../../config';
import { buildURL } from '../../utils';
import { PostCall, ThirdPartyGetCall } from '../helper'

const BASE_API_URL = Config.BASE_API_URL;
const DEFAULT_HEADER = Config.DEFAULT_HEADER;

const URLS = {
    SEND_OTP: BASE_API_URL + "/v3/otp/send_otp",
    VERIFY_OTP: BASE_API_URL + "/v3/otp/verify_otp",
    YOUTUBE_VIDEOS_BASE: 'https://youtube.googleapis.com/youtube/v3/videos',
}


export const SendOTP = async (data: any) => {
  return await PostCall(URLS.SEND_OTP, data, DEFAULT_HEADER);
};

export const VerifyOTP = async (data: any) => {
  return await PostCall(URLS.VERIFY_OTP, data, DEFAULT_HEADER);
};

export const getVideoData = async (params: any) => {
  const url = buildURL(URLS.YOUTUBE_VIDEOS_BASE, params);
  return await ThirdPartyGetCall(url)
};